import { NgModule } from "@angular/core";
import { NewlandScannerFormComponent } from './newland-scanner-form/newland-scanner-form.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { DynamicNewlandScannerComponent } from './dynamic-newland-scanner.component';
import { NewlandScannerDesignComponent } from './newland-scanner-design/newland-scanner-design.component';
import { NewlandScannerResultComponent } from './newland-scanner-result/newland-scanner-result.component';

@NgModule({
    declarations: [
        DynamicNewlandScannerComponent, 
        NewlandScannerFormComponent, 
        NewlandScannerDesignComponent,
        NewlandScannerResultComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule
    ],
    exports: [
        NewlandScannerFormComponent
    ],
    entryComponents: [
        DynamicNewlandScannerComponent
    ]
})
export class NewlandScannerModule {}